export default {"src":"/_next/static/media/ba.0fc81d2a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};